import React from 'react'
import styled from 'styled-components'

// Components
import Icon, { IProps as IconProps } from '../icon/Icon'

// Styles
import { AnyColor } from '../../common/models/colors'

interface IProps extends Omit<IconProps, 'type'> {
  backgroundSize: number
  backgroundColor?: AnyColor
  withBorder?: boolean
}

const ExternIcon: React.FC<IProps> = (props) => {
  return <StyledIcon {...props} type="ExternPeople" />
}

export default ExternIcon

const StyledIcon = styled(Icon)<{
  backgroundSize: number
  backgroundColor?: AnyColor
  withBorder?: boolean
}>`
  width: ${({ backgroundSize }) => backgroundSize}px;
  height: ${({ backgroundSize }) => backgroundSize}px;
  border-radius: 50%;
  border: 2px solid
    ${({ theme, withBorder }) => (withBorder ? theme.colors.lightest : 'none')};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? theme.colors[backgroundColor]
      : theme.colors.textLightest};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;

  > svg {
    position: relative;
  }
`
